module.exports = __webpack_public_path__ + "img/start.34a95198.png";